exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-basic-info-page[data-v-3bcb680c]{padding:0}.settings-basic-info-page__card[data-v-3bcb680c]{max-width:620px}.settings-basic-info-page__input-name[data-v-3bcb680c]{max-width:420px}.settings-basic-info-page__preview-wrap[data-v-3bcb680c]{padding:10px;border:1px solid #ebeef5;border-radius:10px;background:#f8faff;display:inline-block}.settings-basic-info-page__preview[data-v-3bcb680c]{display:block;max-width:240px;max-height:80px;object-fit:contain}.settings-basic-info-page__no-logo[data-v-3bcb680c]{color:#909399;font-size:13px}.settings-basic-info-page__pending[data-v-3bcb680c]{margin-top:8px;font-size:12px;color:#606266}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bcb680c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/SettingsBasicInfo.vue
// module id = +mfq
// module chunks = 0